const isAnz = (country: string) => ['au', 'nz'].includes(country);

export { isAnz };
